
const cookies = { "Auth": {"cookieStorage": {"domain": window.location.hostname,"path": "/","expires": 365,"sameSite": "strict","secure": true}}}

export default cookies;
